// HotLeadList.js
import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import AdminAppBar from "../adminComponents/AdminAppBar";
import LeadTable from "../Form/LeadTable/LeadTable";
import HotLeadFilter from "./HotLeadFilter";
import CustomHeading from "../common/CustomHeading";
import { ToastContainer } from "react-toastify";
import { getIcons, leadCharacterEmoji } from "../Constant/Constant";

import useHotLeads from "../../hooks/useHotLeads";
import {
  getBackgroundClass,
  getStatusBgColor,
  interestLevel,
  statusIcons,
} from "../../Enum/LeadEnumConstants";
import HotLeadHistoryModel from "./HotLeadHistoryModel";
import ConfirmationModal from "../shareableContainer/ConfirmationModal";
import { render } from "@testing-library/react";

const HotLeadList = () => {
  const {
    leads,
    leadDashBoardCount,
    filterVisible,
    setFilterVisible,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    searchQuery,
    setSearchQuery,
    loading,
    currentPage,
    nextPageToken,
    prevPageToken,
    hasMoreLeads,
    countLead,
    pageSize,
    setCountLead,
    userRole,
    isOpen,
    setIsOpen,
    isModalOpen,
    setIsModalOpen,
    isModalOpen2,
    setIsModalOpen2,
    leadAssignStatus,
    setLeadAssignStatus,
    selectedLeadId,
    leadHotHistotyData,
    setLeadHotHistotyData,
    setSelectedLeadId,
    applyFilter,
    clearFilterData,
    handlePageChange,
    handleSearchLead,
    handleLeadInfo,
    handleLeadHotHistory,
    selectedRows,
    setSelectedRows,
    selectedCountLead,
    setSelectedCountLead,
    handleLeadHotHistoryDelete,

    handleHotLeadSend,
    handleHotLeadClick,
    hotLeadCount
  } = useHotLeads();

  const navigate = useNavigate();

  const icon = getIcons();

  console.log("isModalOpen2", isModalOpen2);

  const columns = [
    {
      key: "name",
      title: "Name",
      render: (text, record) => (
        <div
          onClick={() => handleLeadInfo(record)}
          title={text.replace(/\b\w/g, (char) => char.toUpperCase())}
          className="text-blue-500 w-[160px] truncate cursor-pointer text-center"
        >
          {text.replace(/\b\w/g, (char) => char.toUpperCase())}
        </div>
      ),
    },
    {
      key: "phoneNumber",
      title: "Phone Number",
      render: (text, record) => (
        <div className="w-[160px] truncate text-center">
          +{record.countryCode || "91"} {record.phoneNumber}
        </div>
      ),
    },
    {
      key: "status",
      title: "Status",
      render: (value) => {
        const matchedStatus = statusIcons.find((item) => item.label === value);
        if (!matchedStatus)
          return (
            <span className="text-gray-600 text-center w-full">Unknown</span>
          );

        return (
          <div
            className={`${getStatusBgColor(
              matchedStatus?.label
            )} flex items-center justify-center text-center w-44 px-2 gap-2 rounded-full`}
          >
            <img
              src={matchedStatus.image}
              alt={matchedStatus.label}
              className="w-5 h-5"
            />
            <span className="text-gray-700">{matchedStatus.label}</span>
          </div>
        );
      },
    },
    {
      key: "stage",
      title: "stage",
   render : (text) =>{
    return (
      <div>{text || "No Deal"}</div>
    )
   }
    },
    {
      key: "character",
      title: "Team & User",
    render : (text , row) =>{
      return (
        <>
        {row?.assignedTeamName || row?.assignedUserName ? (
          <div>
            {row?.assignedTeamName && <span>{row.assignedTeamName}</span>}
            {row?.assignedTeamName && row?.assignedUserName && <span> / </span>}
            {row?.assignedUserName && <span>{row.assignedUserName}</span>}
          </div>
        ) : (
          <div>No user</div>
        )}
      </>      
      )
    }
    },
    {
      key: "hotLeadCount",
      title: "Count",
     render: (text) =>{
      return (
        <div>
          {text}
        </div>
      )
     }
    },
    {
      key: "lastEnteredDate",
      title: "Last Entered Date",
     render : (value)=>{
      return (
<div>{value}</div>
      )
     }
    },
    {
      key: "action",
      title: "Action",
      render: (text, record) => (
        <div className="w-[100px] flex gap-2 justify-center items-center truncate cursor-pointer text-center">
          <img
            onClick={() => handleLeadHotHistory(record.id)}
            src={icon?.LeadHistotyIcon}
            className="w-5 h-5"
            title="View History"
          />
          <img
            onClick={() => {
              setSelectedLeadId(record.id);
              setIsModalOpen(true);
            }}
            src={icon?.LeadCancelIcon}
            className="w-5 h-5"
            title="Cancel"
          />
          <img
            onClick={() => handleHotLeadClick(record)}
            src={icon?.LeadSendIcon}
            className="w-5 h-5"
            title="Send"
          />
        </div>
      ),
    },
  ];

  const handleFilterLeads = () => setFilterVisible(true);

  return (
    <div className="pt-24 bg-appGrayBackground">
       <AdminAppBar />
      <div className="px-6">
        <div className="py-6">
          <CustomHeading title={"Hot Leads"} isIcon={true} />
        </div>

        <LeadTable
          data={leads}
          hotLead={true}
          hotLeadCount={hotLeadCount}
          columns={columns}
          onPageChange={handlePageChange}
          selectedRows={selectedRows}
          onSelectionChange={setSelectedRows}
          currentPage={currentPage}
          setSearchQuery={setSearchQuery}
          searchQuery={searchQuery}
          handleSearchLead={handleSearchLead}
          loading={loading}
          isSearch={false}
          disPlay={false}
          pageSize={pageSize}
          nextPageToken={nextPageToken}
          prevPageToken={prevPageToken}
          hasMoreLeads={hasMoreLeads}
          handleFilterLeads={handleFilterLeads}
        />
      </div>
      <HotLeadFilter
        visible={filterVisible}
        onHide={() => setFilterVisible(false)}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        selectedCountLead={selectedCountLead}
        setSelectedCountLead={setSelectedCountLead}
        getLocalDate={() => new Date().toISOString().split("T")[0]}
        handleApplyFilter={applyFilter}
        clearFilters={clearFilterData}
      />
      <HotLeadHistoryModel
      selectedLeaddata={leadHotHistotyData}
        isOpen={isOpen}
        isClose={() => {
          setIsOpen(false);
          setLeadHotHistotyData([])
        }}
      />
      <ConfirmationModal
        showModal={isModalOpen}
        title={"Are your sure you want to delete this lead?"}
        message={" This action cannot be undone"}
        onConfirm={() => handleLeadHotHistoryDelete(selectedLeadId)}
        onCancel={() => {
          setIsModalOpen(false);
        }}
      />
<ConfirmationModal
  showModal={isModalOpen2}
  title={leadAssignStatus ? "Assign Lead First" : "Confirm Hot Lead"}
  message={
    leadAssignStatus
      ? "This lead is not assigned. Please assign it manually before marking as hot."
      : "Are you sure you want to mark this lead as hot?"
  }
  confirmText={leadAssignStatus ? "Okay" : "Confirm"}
  onConfirm={() => handleHotLeadSend(selectedLeadId)}
  onCancel={() => setIsModalOpen2(false)}
/>


      <ToastContainer />
    </div>
  );
};

export default HotLeadList;
